import {useEffect, useRef, JoditEditor} from 'external/react'


import {category_unit, frequency_unit, duration} from 'utilities/enum'
import { decimal } from 'utilities/decimal'

import FormTextfield from 'components/FormTextfield'
import FromTo from 'components/FromTo'

import ConfigurationRow from './ConfigurationRow'
import Checkbox from './ConfigurationCheckbox'
import Select from './ConfigurationSelect'

import useAdmin from 'context/admin-context/hook'


export default function Configuration() {

	const editor = useRef(null);
    const {currentOffer, update, validate, resetValidations, errors} = useAdmin()

	useEffect(() => { resetValidations() }, [])
	useEffect(() => { validate(currentOffer, false) }, [currentOffer])

	function textProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			error: errors[fieldName],
			submitted: errors.submitted,
			onChange: (e) => {
                update({currentOffer: {[fieldName]: {$set: e.target.value.trim()}}})
			}
		}
	}

    function checkProps(label, name, type?, fieldName?) {
        return {
            label,
            name,
            type,
            value: currentOffer[fieldName || name],
            onChange: e => update({currentOffer: {[fieldName || name]: {$set: e.target[type === 'radio' ? 'value' : 'checked']}}})
        }
    }
    function selectProps(label, name, items) {
        return {
            label,
            onChange: e => update({currentOffer: {[name]: {$set: e.target.value}}}),
            items
        }
    }

    function handleHTMLChange(html) {
        update({currentOffer: {content: {html: {$set: html}}}})
    }

    return (
        <>
            <ConfigurationRow label='Nombre de la oferta'>
                <FormTextfield {...textProps('', 'name')} value={currentOffer.name} /> 
            </ConfigurationRow>
            <ConfigurationRow label='Categoría y término'>
                <Select defaultValue={currentOffer.category_unit} {...selectProps("Categoría", "category_unit", category_unit)} />
                <Select defaultValue={currentOffer.frequency_unit} {...selectProps("Término", "frequency_unit", frequency_unit)} />
           </ConfigurationRow>
            <ConfigurationRow label="Precio">
                <FormTextfield {...textProps('', 'price')} defaultValue={currentOffer.price} /> 
            </ConfigurationRow>
        <ConfigurationRow label="Descuento">
            <Checkbox checked={currentOffer.discount} {...checkProps("Descuento de oferta", "discount")} />
        </ConfigurationRow>
        {currentOffer.discount && (<>
            <ConfigurationRow label='Descuento'>
                <FormTextfield defaultValue={currentOffer.discount_name} {...textProps('Descuento de la primera compra', 'discount_name')} />
            </ConfigurationRow>
            <ConfigurationRow label='Cantidad a descontar'>
                <FormTextfield onKeyDown={ (e) => decimal(e) } defaultValue={currentOffer.discount_amount} {...textProps('', 'discount_name')} />
                <Checkbox checked={currentOffer.discount_type === 'percent'} {...checkProps("Descuento de oferta", "percent", "radio", "discount_type")} />
                <Checkbox checked={currentOffer.discount_type === 'quantity'} {...checkProps("Cantidad fija", "quantity", "radio", "discount_type")} />
            </ConfigurationRow>
           <ConfigurationRow label="Duración">
                <Select defaultValue={currentOffer.duration} {...selectProps("Duración", "discount", duration)} />
                <FormTextfield defaultValue={currentOffer.month_number} {...textProps('Cantidad de meses', 'month_number')} />
           </ConfigurationRow>
           <ConfigurationRow label="Fechas">
                <FromTo start={currentOffer.discount_startdate} end={currentOffer.discount_duedate} onChange={(type, value) => {
                    update({currentOffer: {[type === 'start' ? 'discount_startdate' : 'discount_duedate']: {$set: value}}})
                }}/>                
           </ConfigurationRow>
        </>)}
       <ConfigurationRow label="Descripcpión">
            <JoditEditor ref={editor} value={currentOffer.content.html} tabIndex={1} onBlur={handleHTMLChange} />
       </ConfigurationRow>
   </>) 
}